import { TabsLayout, Copy, Controls, Media, Content, Control } from './TabsLayout';
TabsLayout.displayName = "TabsLayoutBase";
Copy.displayName = "TabsLayout.Copy";
Controls.displayName = "TabsLayout.Controls";
Media.displayName = "TabsLayout.Media";
Content.displayName = "TabsLayout.Content";
Control.displayName = "TabsLayout.Control";
export { default, Copy, Media, Controls, Content, Control } from './TabsLayout';